import { module } from 'modujs';
import { DEFAULT_VUE_FORM, DEFAULT_VUE_DATA } from '../utils/form'

const { required, requiredIf, email, url } = window.validators;

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$el = this.el
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        // Init vue
        this.openingId = this.getData('opening-id');
        this.language = this.getData('language');
        this.initVue();
    }

    destroy() {
        super.destroy();
        this.app?.$destroy?.()
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default);

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            ...DEFAULT_VUE_FORM,

            el: this.el,
            mixins: [{
                data: DEFAULT_VUE_DATA(this.el),
            }],
            components: {
                FilePond: vueFilePond.default(
                    FilePondPluginFileValidateType,
                    FilePondPluginFileValidateSize
                )
            },
            data() {
                return {
                    formData: {
                        openingId: moduleInstance.openingId,
                        officeId: '',
                        firstName: '',
                        lastName: '',
                        email: '',
                        phoneNumber: '',
                        linkedin: '',
                        resume: '',
                        message: '',
                        language: moduleInstance.language,
                        referredFrom: '',
                        wantsNewsletter: false,
                    }
                }
            },

            watch: {
                '$v': {
                    deep: true,
                    immediate: true,
                    handler(_value) {
                        this.moduleInstance?.call('update', null, 'Scroll')
                    }
                },
            },

            validations: {
                ...DEFAULT_VUE_FORM.validations.formData,

                formData: {
                    officeId: {},
                    firstName: {
                        required
                    },
                    lastName: {
                        required
                    },
                    email: {
                        required,
                        email
                    },
                    phoneNumber: {
                        required
                    },
                    message: {},
                    referredFrom: {},
                    wantsNewsletter: {},
                    linkedin: {
                        required: requiredIf((formData) => formData.resume.length < 1),
                        url
                    },
                    resume: {
                        required: requiredIf((formData) => formData.linkedin === '')
                    }
                }
            },

            created() {
                //Important to make scrollTo error working
                this.moduleInstance = moduleInstance
            },

            mounted() {
            },

            methods: {
                ...DEFAULT_VUE_FORM.methods,

                onSendDataSuccess: (response) => {
                     moduleInstance.call('goTo', { url: response.feedbackUrl, transition: null }, 'Load')
                },

                handleFilePondInit: () => {
                    // console.log("FilePond has initialized");
                    //
                    // FilePond instance methods are available on `this.$refs.pond`
                },

                // not used, only use process
                handleAddResumeFile: function (_error, file) {
                    this.formData.resume = file.file.name
                },
                handleRemoveResumeFile: function (_error, _file) {
                    this.formData.resume = ''
                },
                handleProcessResumeFile: function (_error, file) {
                    if (file?.serverId) {
                        this.formData.resume = file.serverId
                    }
                },
            }
        });
    }
}
